var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 194,
    height: 136,
    viewBox: "0 0 194 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4393_123640)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 9,
    width: 51,
    height: 51,
    rx: 25.5,
    transform: "rotate(90 82 9)",
    fill: "#F1EDF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.0006 116.286C123.668 116.286 145.286 94.6679 145.286 68.0001C145.286 41.3326 123.668 19.7144 97.0006 19.7144C70.3331 19.7144 48.7148 41.3326 48.7148 68.0001C48.7148 94.6679 70.3331 116.286 97.0006 116.286Z",
    stroke: "url(#paint0_linear_4393_123640)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.669 51.2856L88.9548 88.4285L74.0977 77.2856",
    stroke: "url(#paint1_linear_4393_123640)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171,
    y: 109,
    width: 12,
    height: 12,
    rx: 6,
    transform: "rotate(90 171 109)",
    fill: "#00FFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.601 27.509C172.051 27.6737 172.05 28.326 171.601 28.4905C165.726 30.6413 163.641 32.7253 161.49 38.6008C161.326 39.0502 160.674 39.0504 160.509 38.601C158.357 32.7277 156.274 30.6438 150.399 28.491C149.949 28.3263 149.95 27.674 150.399 27.5095C156.274 25.3587 158.359 23.2747 160.51 17.3992C160.674 16.9498 161.326 16.9496 161.491 17.399C163.643 23.2723 165.726 25.3562 171.601 27.509Z",
    fill: "url(#paint2_linear_4393_123640)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4393_123640",
    x1: 144.189,
    y1: 67.2085,
    x2: -13.5276,
    y2: 120.294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859293,
    stopColor: "#9747FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4393_123640",
    x1: 118.163,
    y1: 69.5526,
    x2: 48.49,
    y2: 97.6938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859293,
    stopColor: "#9747FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4393_123640",
    x1: 172.727,
    y1: 27.8033,
    x2: 133.531,
    y2: 40.9961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB3366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859293,
    stopColor: "#9747FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4393_123640"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 194,
    height: 136,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.e973b359145eeee34c34c6c836cd36f3.svg";
export { ForwardRef as ReactComponent };